import React, { Component, PropTypes } from 'react';
import login from './../login.js';
import menuesRootview from './../menues_rootview.js';

class LoginForm extends Component {
	componentWillMount() {
		login.openLoginFrom();
		menuesRootview.openLoginMenu();
	}

	componentWillUnmount() {
		login.closeLoginForm();
		menuesRootview.close();
	}

	render() {
		return (
			<div id="login" />
		);
	}
}

export default LoginForm;



// WEBPACK FOOTER //
// ./mobile-core/src/components/login-form.js